import { motion } from 'framer-motion';
import { Badge } from '../ui/badge';

export const AdminPurchasesTab = ({ purchases }) => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="bg-card border border-border overflow-x-auto"
    >
      <table className="w-full">
        <thead className="bg-black">
          <tr>
            <th className="text-left p-4 text-muted-foreground font-heading uppercase text-sm">User</th>
            <th className="text-left p-4 text-muted-foreground font-heading uppercase text-sm">Program</th>
            <th className="text-left p-4 text-muted-foreground font-heading uppercase text-sm">Amount</th>
            <th className="text-left p-4 text-muted-foreground font-heading uppercase text-sm">Method</th>
            <th className="text-left p-4 text-muted-foreground font-heading uppercase text-sm">Status</th>
            <th className="text-left p-4 text-muted-foreground font-heading uppercase text-sm">Date</th>
          </tr>
        </thead>
        <tbody>
          {purchases.map((tx) => (
            <tr key={tx.id} className="border-t border-border hover:bg-white/5">
              <td className="p-4">
                <div>
                  <p className="text-white font-medium">{tx.user_name}</p>
                  <p className="text-muted-foreground text-sm">{tx.user_email}</p>
                </div>
              </td>
              <td className="p-4">
                <span className="text-white">{tx.program_title || tx.program_name}</span>
              </td>
              <td className="p-4">
                <span className="text-green-400 font-heading">${tx.amount}</span>
              </td>
              <td className="p-4">
                <Badge className={`${tx.payment_method === 'stripe' ? 'bg-purple-500/20 text-purple-400' : 'bg-blue-500/20 text-blue-400'}`}>
                  {tx.payment_method}
                </Badge>
              </td>
              <td className="p-4">
                <Badge className={`${tx.status === 'completed' ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
                  {tx.status}
                </Badge>
              </td>
              <td className="p-4">
                <span className="text-muted-foreground text-sm">
                  {new Date(tx.created_at).toLocaleDateString()}
                </span>
              </td>
            </tr>
          ))}
          {purchases.length === 0 && (
            <tr>
              <td colSpan="6" className="p-8 text-center text-muted-foreground">
                No purchases yet
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </motion.div>
  );
};
